import React from 'react'
import AppointmentAccessReasonRendererHelper from '../../../components/AgGrid/RendererHelper/AppointmentAccessReasonRendererHelper'

const AppointmentAccessRenderer = (props) => {
  const { value } = props
  return <AppointmentAccessReasonRendererHelper value={value} />
}

export default AppointmentAccessRenderer
